/**
 * The Firebase project behind "Continue with Google".
 *
 * Kept here rather than in the environment because none of it is secret: the
 * same values are handed to every visitor in the JavaScript bundle, and they
 * identify the project rather than grant access to it. What actually guards
 * sign-in is the list of authorised domains in the Firebase console — a host not
 * on it cannot open the sign-in window at all, whoever has these values.
 */
const firebaseConfig = {
  apiKey: 'AIzaSyAWir008X0wO_6TsDDQ3XKWySDBY3Z2cIo',
  authDomain: 'ontheweb-app.firebaseapp.com',
  projectId: 'ontheweb-app',
  storageBucket: 'ontheweb-app.firebasestorage.app',
  messagingSenderId: '675260406685',
  appId: '1:675260406685:web:77a2746f8b8ef7914dad74',
  measurementId: 'G-GNN4XQH2QJ',
};

/**
 * Opens the Google account chooser and returns the Firebase ID token for whoever
 * signed in — the server takes it from there. Returns null when the person
 * closed the window, which is a change of mind rather than an error.
 *
 * Firebase is imported here rather than at the top of the file so that it becomes
 * its own chunk, fetched when the button is pressed: it is a third of a megabyte
 * of JavaScript that nobody signing in with a mobile number needs.
 */
export async function signInWithGoogle(): Promise<string | null> {
  const [{ getApp, getApps, initializeApp }, { GoogleAuthProvider, getAuth, signInWithPopup }] =
    await Promise.all([import('firebase/app'), import('firebase/auth')]);

  const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

  const provider = new GoogleAuthProvider();
  // Always ask which account, rather than silently reusing the one Google
  // happens to be signed in to in this browser.
  provider.setCustomParameters({ prompt: 'select_account' });

  try {
    const credential = await signInWithPopup(getAuth(app), provider);
    return await credential.user.getIdToken();
  } catch (error: any) {
    const code = String(error?.code || '');
    if (
      code === 'auth/popup-closed-by-user' ||
      code === 'auth/cancelled-popup-request' ||
      code === 'auth/user-cancelled'
    ) {
      return null;
    }
    throw error;
  }
}
